import { Injectable } from "@angular/core";
import { IPlannedEvent, PlannedEventCreator, PlannedEventUpdater } from "@ramudden/models/planned-event";
import { IWorker } from "@ramudden/models/worker";
import moment from "moment";
import { firstValueFrom, Observable } from "rxjs";
import { ApiService } from "./api";

@Injectable({
    providedIn: "root",
})
export class PlannedEventApi extends ApiService<IPlannedEvent, PlannedEventCreator, PlannedEventUpdater> {
    override getRoute(): string {
        return "PlannedEvents";
    }

    copyWeek$(startingDateOfWeekWhichNeedsToBeCopied: Date): Observable<void> {
        return this.http.post<void>(
            `${this.getUrl()}/CopyWeek?startOfTheWeekWhichNeedsToBeCopied=${startingDateOfWeekWhichNeedsToBeCopied.toISOString()}`,
            null,
        );
    }

    async endWorkday(plannedEventId: number): Promise<void> {
        return await firstValueFrom(
            this.http.post<void>(`${this.getUrl()}/EndWorkdayFromWebsite/${plannedEventId}`, null),
        );
    }

    async revertEndWorkday(plannedEventId: number): Promise<void> {
        return await firstValueFrom(
            this.http.post<void>(`${this.getUrl()}/RevertEndWorkdayFromWebsite/${plannedEventId}`, null),
        );
    }

    availableWorkersForDate$(date: Date): Observable<IWorker[]> {
        return this.http.get<IWorker[]>(
            `${this.getUrl()}/AvailableWorkersForDate?forDate=${moment(date).format("YYYY/MM/DD")}`,
        );
    }
}
